import React from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function StackedBarChart({ datasets, labels, title }) {
  return (
    <Bar
      data={{
        labels,
        datasets,
      }}
      options={{
        indexAxis: "x",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
          },
          title: {
            display: title ? true : false,
            text: title,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const datasetLabel = context.dataset.label || '';
                const value = context.raw;

                // Calcola il totale dello stack nella stessa posizione
                const total = context.chart.data.datasets
                  .filter(ds => ds.stack === context.dataset.stack) // solo dello stesso stack
                  .reduce((sum, ds) => sum + (ds.data[context.dataIndex] || 0), 0);

                const percentage = total ? ((value / total) * 100).toFixed(1) : 0;
                return `${datasetLabel}: ${value} (${percentage}%)`;
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
            ticks: {
              // stepSize: 1,
              callback: function (value) {
                if (Number.isInteger(value)) {
                  return value;
                }
              },
            },
          },
        },
      }}
    />
  );
}

StackedBarChart.propTypes = {
  datasets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      backgroundColor: PropTypes.string.isRequired,
      stack: PropTypes.string,
    }),
  ).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
};
